<div [hidden]="!tablets" class="animated fadeIn">
    <table-component (onEdit)="onEdit($event)" id="table_tablets"></table-component>
</div>

<kiosk-tablets-edit-component></kiosk-tablets-edit-component>
